<div class="container">
    <div class="row no-gutters">
      <div class="col-12">
        <div class="d-flex popup-head align-items-center">
          <div class="popup-title mr-auto" translate>
            <ng-container translate>
              lblViewAccount
            </ng-container>
          </div>
          <div class="float-right">
            <a class="close mr-2" (click)="OnClose()" translate>
              <span class="" aria-hidden="true">&times;</span>
              </a>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-between bg-grey">
          <ul ngbNav #nav="ngbNav" class="nav-tabs">
            <li *ngFor="let tab of tabs | slice:0:noOfTabLimit; let i=index" class="nav-item" >
              <a translate class="nav-link" (click)="tabSelected(tab.id)"  [ngClass]="{'active': selectedtab===tab.id}">{{tab.label}}</a>
            </li>
          </ul>
          <div class="fs-16px mr-4" *ngIf="accountId">
            <ng-cotainer class="clrBlue semibold text-capitalize">
              <em class="fas fa-user mr-2"></em>{{accountName}}</ng-cotainer>
            <ng-cotainer class="mbold" *ngIf="accountNo != ''">&nbsp;&nbsp;-&nbsp;&nbsp;#{{accountNo}}</ng-cotainer>
          </div>
        </div>
        <ng-cotainer *ngIf="selectedtab===1">
          <app-account-details></app-account-details>
        </ng-cotainer>
        <ng-cotainer *ngIf="selectedtab===2">
          <app-contact-details (backToFirstTab)="backToFirstTab()"></app-contact-details>
        </ng-cotainer>
      </div>
    </div>
  </div>
  